import { render, staticRenderFns } from "./about_withdraw.vue?vue&type=template&id=53aab9e2&scoped=true"
import script from "./about_withdraw.vue?vue&type=script&lang=js"
export * from "./about_withdraw.vue?vue&type=script&lang=js"
import style0 from "./about_withdraw.vue?vue&type=style&index=0&id=53aab9e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aab9e2",
  null
  
)

export default component.exports